import type { Language } from './language';

/** Regional language tags with their own translation bundle. */
export enum LanguageVariant {
  SPANISH_SPAIN = 'es-ES',
}

/** A known language or variant tag, or any other tag a host provides. */
export type LanguageTag = `${Language | LanguageVariant}` | (string & {});
